import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

export const useInitialReportUsageLoadEffect = ({
  storedItemTableData,
  setFilteredProduct,
  storedPriceOverrideReason,
  storedPricingNotes,
  setPriceOverrideReason,
  setPricingNotes,
  storedPatientDetails,
  setPatientDetail,
  dispatch,
  setPatientDetails,
  storedSignatureDetails,
  setLocalSignature,
}) => {
  useEffectWithErrorLogging(() => {
    if (storedItemTableData?.length > 0) {
      setFilteredProduct(storedItemTableData);
      if (
        storedItemTableData.some(
          (x) => x.adjustedUsedQtyPrice || x.adjustedOtherQtyPrice
        ) &&
        storedPriceOverrideReason?.length > 0 &&
        storedPricingNotes?.length > 0
      ) {
        setPriceOverrideReason(storedPriceOverrideReason);
        setPricingNotes(storedPricingNotes);
      }
    }
    if (
      storedPatientDetails &&
      Object.values(storedPatientDetails).length > 0 &&
      Object.values(storedPatientDetails).some((x) => x?.length > 0)
    ) {
      setPatientDetail(storedPatientDetails);
      dispatch(setPatientDetails(storedPatientDetails));
    }
    if (
      storedSignatureDetails &&
      Object.values(storedSignatureDetails)?.length > 0 &&
      Object.values(storedSignatureDetails).every((x) => x?.length > 0)
    ) {
      dispatch(setLocalSignature(storedSignatureDetails));
    }
  }, []);
};